import { render } from "./TvmAppointmentAddress.vue?vue&type=template&id=f887317e&scoped=true"
import script from "./TvmAppointmentAddress.vue?vue&type=script&lang=js"
export * from "./TvmAppointmentAddress.vue?vue&type=script&lang=js"

import "./TvmAppointmentAddress.vue?vue&type=style&index=0&id=f887317e&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f887317e"]])

export default __exports__